/**
 * Bridge Recharge Storefront cart drawer → Horizon cart page.
 * Qty/line changes in the Recharge drawer update Shopify cart, but do not
 * emit Horizon's `cart:update`, so /cart stays stale until refresh.
 */
(function () {
  var HOST_SELECTOR = '#recharge-storefront-experiences__cart-drawer';
  var syncTimer = null;
  var lastSignature = '';
  var syncing = false;

  function shopifyRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/');
  }

  function cartSignature(cart) {
    if (!cart) return '';
    var parts = [(cart.item_count || 0).toString()];
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      parts.push(String(it.key || it.id || '') + ':' + String(it.quantity || 0));
    }
    return parts.join('|');
  }

  function dispatchHorizonCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          data: {
            source: 'recharge-cart-drawer',
            itemCount: cart && cart.item_count
            // No sections → cart-items-component re-renders via sectionRenderer
          }
        }
      })
    );

    ['cart:updated', 'cart:refresh'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: cart }));
    });

    if (cart && typeof cart.item_count === 'number') {
      document.dispatchEvent(
        new CustomEvent('cart:item-count', {
          bubbles: true,
          detail: { count: cart.item_count }
        })
      );
    }
  }

  function syncFromShopifyCart() {
    if (syncing) return;
    syncing = true;
    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var sig = cartSignature(cart);
        if (sig === lastSignature) return;
        lastSignature = sig;
        dispatchHorizonCartUpdate(cart);
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
      });
  }

  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
 
    syncTimer = setTimeout(syncFromShopifyCart, 350);
  }

  function looksLikeCartInteraction(target) {
    if (!target || !target.closest) return true;
    var el = target.closest(
      'button, [role="button"], input, select, a, [data-testid], [class*="quantity"], [class*="qty"], [class*="remove"], [aria-label]'
    );
    return !!el;
  }

  function bindShadow(shadow) {
    if (!shadow || shadow.__peRechargeCartSyncBound) return;
    shadow.__peRechargeCartSyncBound = true;

    shadow.addEventListener(
      'click',
      function (e) {
        if (looksLikeCartInteraction(e.target)) scheduleSync();
      },
      true
    );
    shadow.addEventListener('change', scheduleSync, true);
    shadow.addEventListener('input', scheduleSync, true);

    var mutTimer = null;
    new MutationObserver(function () {
      if (mutTimer) clearTimeout(mutTimer);
      mutTimer = setTimeout(scheduleSync, 400);
    }).observe(shadow, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function tryBind() {
    var host = document.querySelector(HOST_SELECTOR);
    if (!host) return;
    if (host.shadowRoot) {
      bindShadow(host.shadowRoot);
      return;
    }

    try {
      var probe = new MutationObserver(function () {
        if (host.shadowRoot) {
          probe.disconnect();
          bindShadow(host.shadowRoot);
        }
      });
      probe.observe(host, { childList: true, subtree: true, attributes: true });
    } catch (e) {}
  }

  function boot() {
    tryBind();
    if (document.body) {
      new MutationObserver(tryBind).observe(document.body, { childList: true, subtree: true });
    }

    fetch(shopifyRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) lastSignature = cartSignature(cart);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  ['recharge:cart:updated', 'rc::cart-updated', 'storefront:cart:updated'].forEach(function (name) {
    document.addEventListener(name, scheduleSync);
    window.addEventListener(name, scheduleSync);
  });
})();
